class ConsoleLogger {
  constructor(adInstance) {
    this.debugMode = adInstance.debugMode;
  }

  debug(...restArgs) {
    if (this.debugMode) {
      console.log('%c Message: ', 'background: #222; color: #ebba34', ...restArgs);
    }
  }

  error(...restArgs) {
    if (this.debugMode) {
      console.error('%c Error: ', 'background: #222; color: #ebba34', ...restArgs);
    }
  }
}

export default ConsoleLogger;
